export const getCurDate = (date) => {
  let dt = date || new Date();
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${new_dt
    .getFullYear()
    .toString()
    .padStart(4, "0")}-${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new_dt.getDate().toString().padStart(2, "0")}`;

  return current_timezone_time;
};

export const getConvertedDate = (val) => {
  if(!val) return null
  let dt = val;
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${new_dt
    .getDate()
    .toString()
    .padStart(2, "0")}/${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${new_dt.getFullYear().toString().padStart(4, "0")}`;

  return current_timezone_time;
};

export const getConvertedDate4 = (val) => {
  let dt = val;
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${new_dt
      .getDate()
      .toString()
      .padStart(2, "0")}/${new_dt.getFullYear().toString().padStart(4, "0")}`;

  return current_timezone_time;
};



export const getConvertedDate2 = (val) => {
  let dt = val;
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${new_dt
    .getFullYear()
    .toString()
    .padStart(4, "0")}-${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new_dt.getDate().toString().padStart(2, "0")}`;

  return current_timezone_time;
};

export const getConvertedDate3 = (val) => {
  let dt = val;
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${new_dt
    .getFullYear()
    .toString()
    .padStart(4, "0")}-${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new_dt.getDate().toString().padStart(2, "0")}`;

  return current_timezone_time;
};

export const getCurDateTime = () => {
  let dt = new Date();
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_time = `${new_dt
    .getFullYear()
    .toString()
    .padStart(4, "0")}-${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new_dt.getDate().toString().padStart(2, "0")} ${new_dt
    .getHours()
    .toString()
    .padStart(2, "0")}:${new_dt
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${new_dt.getSeconds().toString().padStart(2, "0")}`;

  return current_timezone_time;
};

export const Gender = [
  {
    id: "1",
    name: "Male",
  },
  {
    id: "2",
    name: "Female",
  },
  {
    id: "3",
    name: "Others",
  },
];

export const loadScript = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

export const timeVal = (today)=>{
  let currentHour = today.getHours().toString().length === 1 ? `0${today.getHours()}` : today.getHours()
  let currentMin = today.getMinutes().toString().length === 1 ? `0${today.getMinutes()}` : today.getMinutes()
  return currentHour + ":" + currentMin < '19:00'
}

export function inWords(num) {
  const getNum = num.split('.')[0]
  const getNum1 = num.split('.')[1]

  if (getNum.length > 9) return 'overflow';

  function price_in_words(price) {
      var sglDigit = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"],
        dblDigit = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"],
        tensPlace = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"],
        handle_tens = function(dgt, prevDgt) {
          return 0 == dgt ? "" : " " + (1 == dgt ? dblDigit[prevDgt] : tensPlace[dgt])
        },
        handle_utlc = function(dgt, nxtDgt, denom) {
          return (0 != dgt && 1 != nxtDgt ? " " + sglDigit[dgt] : "") + (0 != nxtDgt || dgt > 0 ? " " + denom : "")
        };
    
      var str = "",
        digitIdx = 0,
        digit = 0,
        nxtDigit = 0,
        words = [];
      if (price += "", isNaN(parseInt(price))) str = "";
      else if (parseInt(price) > 0 && price.length <= 10) {
        for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--) switch (digit = price[digitIdx] - 0, nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0, price.length - digitIdx - 1) {
          case 0:
            words.push(handle_utlc(digit, nxtDigit, ""));
            break;
          case 1:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 2:
            words.push(0 != digit ? " " + sglDigit[digit] + " Hundred" + (0 != price[digitIdx + 1] && 0 != price[digitIdx + 2] ? " and" : "") : "");
            break;
          case 3:
            words.push(handle_utlc(digit, nxtDigit, "Thousand"));
            break;
          case 4:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 5:
            words.push(handle_utlc(digit, nxtDigit, "Lakh"));
            break;
          case 6:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 7:
            words.push(handle_utlc(digit, nxtDigit, "Crore"));
            break;
          case 8:
            words.push(handle_tens(digit, price[digitIdx + 1]));
            break;
          case 9:
            words.push(0 != digit ? " " + sglDigit[digit] + " Hundred" + (0 != price[digitIdx + 1] || 0 != price[digitIdx + 2] ? " and" : " Crore") : "")
        }
        str = words.reverse().join("")
      } else str = "";
      return str
    
    }

  let getStr = price_in_words(+getNum);
  let newStr = price_in_words(+getNum1);

  if (getNum1) {
      getStr += newStr ? 'and ' + newStr + 'paise Only' : 'Only'
  }else{
    getStr += ' Only'
  }

  return getStr;
}

export const getCurTime = (date) => {
  let dt = new Date(date);
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let current_timezone_date = `${new_dt
    .getDate()
    .toString()
    .padStart(2, "0")}/${(new_dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${new_dt.getFullYear().toString().padStart(4, "0")}`;
  var hourEnd = date.indexOf(":");
  var H = date.slice(10, hourEnd);
  var h = H % 12 || 12;
  var ampm = H < 12 ? " AM" : " PM";
  let time = h + date.substr(hourEnd, 3) + ampm;
  // document.write(time);
  return time;
};

export const time = [
  {time: "12:00 AM"},
  {time: "12:30 AM"},
  {time: "01:00 AM"},
  {time: "01:30 AM"},
  {time: "02:00 AM"},
  {time: "02:30 AM"},
  {time: "03:00 AM"},
  {time: "03:30 AM"},
  {time: "04:00 AM"},
  {time: "04:30 AM"},
  {time: "05:00 AM"},
  {time: "05:30 AM"},
  {time: "06:00 AM"},
  {time: "06:30 AM"},
  {time: "07:00 AM"},
  {time: "07:30 AM"},
  {time: "08:00 AM"},
  {time: "08:30 AM"},
  {time: "09:00 AM"},
  {time: "09:30 AM"},
  {time: "10:00 AM"},
  {time: "10:30 AM"},
  {time: "11:00 AM"},
  {time: "11:30 AM"},
  {time: "12:00 PM"},
  {time: "12:30 PM"},
  {time: "01:00 PM"},
  {time: "01:30 PM"},
  {time: "02:00 PM"},
  {time: "02:30 PM"},
  {time: "03:00 PM"},
  {time: "03:30 PM"},
  {time: "04:00 PM"},
  {time: "04:30 PM"},
  {time: "05:00 PM"},
  {time: "05:30 PM"},
  {time: "06:00 PM"},
  {time: "06:30 PM"},
  {time: "07:00 PM"},
  {time: "07:30 PM"},
  {time: "08:00 PM"},
  {time: "08:30 PM"},
  {time: "09:00 PM"},
  {time: "09:30 PM"},
  {time: "10:00 PM"},
  {time: "10:30 PM"},
  {time: "11:00 PM"},
  {time: "11:30 PM"},
]

export const getTime = (val) => {
  let dt = val;
  let localTime = dt.getTime();
  let localOffset = dt.getTimezoneOffset() * 60000;
  let utc = localTime + localOffset;
  let offset = 5.5;
  let IST = utc + 3600000 * offset;
  let new_dt = new Date(IST);
  let time = `${new_dt
    .getHours()
    .toString()
    .padStart(2, "0")}`;

  return time;
};

export const getTodayInputDate = () => {
  const now = new Date();
  return `${now.getFullYear()}-${`${now.getMonth() + 1}`.padStart(2, "0")}-${`${now.getDate()}`.padStart(2, "0")}`;
};

export const to12HourTime = (val) => {
  const [h, m] = `${val || ""}`.split(":");
  if (h === undefined || m === undefined) return val || "";

  const hour = +h;
  if (Number.isNaN(hour)) return val;

  const suffix = hour < 12 ? "AM" : "PM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;

  return `${`${hour12}`.padStart(2, "0")}:${m} ${suffix}`;
};

export const byCafeteria = (list, cafeteriaId) =>
  (list || []).filter(
    (row) => row.nCafeteriaId === null || row.nCafeteriaId === undefined || +row.nCafeteriaId === +cafeteriaId
  );

// ---------------------------------------------------------------------------
// Vendor <-> cafeteria, from the roster.
//
// tblRosterMaster says which vendor serves a cafeteria over a date range (the
// latest roster row wins when ranges overlap). Bookings, carts and menus are
// still keyed by cafeteria, so the selected vendor is resolved to the
// cafeteria(s) it serves on the date in question.
// ---------------------------------------------------------------------------

const MONTHS = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
const pad2 = (n) => `${n}`.padStart(2, "0");

// Any date the app or the server hands around -> 'YYYY-MM-DD' (comparable as a string)
export const toDayKey = (val) => {
  if (!val) return null;
  if (val instanceof Date) return Number.isNaN(val.getTime()) ? null : getConvertedDate2(val);

  const s = `${val}`.trim();
  let m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/); // 2026-10-13, 2026-10-13T00:00:00.000Z
  if (m) return `${m[1]}-${pad2(m[2])}-${pad2(m[3])}`;

  m = s.match(/^(\d{1,2})[- ]([A-Za-z]{3})[A-Za-z]*[- ](\d{4})/); // 13-Oct-2026
  if (m && MONTHS[m[2].toLowerCase()]) return `${m[3]}-${pad2(MONTHS[m[2].toLowerCase()])}-${pad2(m[1])}`;

  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/); // 13/10/2026
  if (m) return `${m[3]}-${pad2(m[2])}-${pad2(m[1])}`;

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : getConvertedDate2(d);
};

// cafeteriaId -> roster row in force on that day
const rosterOn = (roster, date) => {
  const day = toDayKey(date);
  const winners = {};
  if (!day) return winners;

  (roster || []).forEach((r) => {
    const from = toDayKey(r.fromDate);
    const to = toDayKey(r.ToDate || r.toDate);
    if (!from || !to || day < from || day > to) return;

    const cafe = +r.CafeteriaID;
    if (!winners[cafe] || +r.nID > +winners[cafe].nID) winners[cafe] = r;
  });
  return winners;
};

export const vendorOf = (roster, cafeteriaId, date) => {
  const row = rosterOn(roster, date)[+cafeteriaId];
  return row ? +row.VendorID : null;
};

// Every cafeteria the vendor serves on that day, lowest id first
export const vendorCafeterias = (roster, vendorId, date) =>
  Object.values(rosterOn(roster, date))
    .filter((r) => +r.VendorID === +vendorId)
    .map((r) => +r.CafeteriaID)
    .sort((a, b) => a - b);

// The cafeteria a new booking for this vendor on this day is recorded against
export const vendorCafeteriaId = (roster, vendorId, date) =>
  vendorCafeterias(roster, vendorId, date)[0] ?? null;

// Vendors serving on that day: [{ id, name, cafeteriaId }]
export const vendorsOn = (roster, date) => {
  const byVendor = {};
  Object.values(rosterOn(roster, date)).forEach((r) => {
    const id = +r.VendorID;
    if (!byVendor[id] || +r.CafeteriaID < byVendor[id].cafeteriaId) {
      byVendor[id] = { id, name: r.cVendorName, cafeteriaId: +r.CafeteriaID };
    }
  });
  return Object.values(byVendor).sort((a, b) => `${a.name}`.localeCompare(`${b.name}`));
};

// Vendors rostered on or after that day: [{ id, name }]
export const upcomingVendors = (roster, date = new Date()) => {
  const day = toDayKey(date);
  const byVendor = {};
  (roster || []).forEach((r) => {
    const to = toDayKey(r.ToDate || r.toDate);
    if (!to || to < day) return;
    byVendor[+r.VendorID] = { id: +r.VendorID, name: r.cVendorName };
  });
  return Object.values(byVendor).sort((a, b) => `${a.name}`.localeCompare(`${b.name}`));
};

// What checkout sends so only the vendor's cart lines are booked, and the
// gateway is the one of the vendor rostered for them
export const vendorCheckout = (cartList) => ({
  cartIds: (cartList || []).map((d) => d.NID),
  nCafeteriaId: cartList?.[0]?.nCafeteriaId ?? null,
  dOrderDate: cartList?.[0]?.dOrderDate ?? null,
});

// Keeps the rows (cart lines, orders) that belong to the vendor
export const byVendor = (list, roster, vendorId) =>
  (list || []).filter(
    (row) =>
      row.nCafeteriaId === null ||
      row.nCafeteriaId === undefined ||
      vendorOf(roster, row.nCafeteriaId, row.dOrderDate) === +vendorId
  );
